export function getEnv(key) {
  return import.meta.env[key];
}

export function isProduction() {
  return import.meta.env.PROD;
}
